module.exports = __webpack_public_path__ + "media/styles/images/png/eraser-gray-dark-53c6974123cc9a677bd379d99f71b800.png";